import { memo } from 'react';
import { nullIfEmpty } from '@utils/nullIfEmpty';
import { BigCheckBoxInput } from '../BigCheckBoxInput';
import {
  BigInputDiv,
  BigInputRowDiv,
  GlobalHeader,
  InputList,
} from '../styles';
import { NOT_APPLICABLE } from './constants';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew, showCheckbox } from './utils';

type FirmwareInputGroupProps = PropsInputGlobal<
  'installedFirmwareVersion' | 'installedSoftwareVersion'
>;

export function FirmwareInputGroup(props: FirmwareInputGroupProps) {
  const { installedFirmwareVersion, installedSoftwareVersion } = props;
  const { setGlobalFormV, setFormV } = props;
  const firmwareName = `installedFirmwareVersion` as const;
  const softwareName = `installedSoftwareVersion` as const;

  return (
    <InputList>
      <BigInputDiv>
        <GlobalHeader>Installed Firmware Version</GlobalHeader>
        <BigInputRowDiv>
          <BigCheckBoxInput
            placeholder="Firmware Version"
            value={installedFirmwareVersion ?? ''}
            showCheckbox={showCheckbox(installedFirmwareVersion)}
            isDisabled={installedFirmwareVersion === NOT_APPLICABLE}
            onClick={() => {
              let flippedValue: string | null = NOT_APPLICABLE;
              if (installedFirmwareVersion === NOT_APPLICABLE) {
                flippedValue = null;
              }
              onChangeGlobal(firmwareName, flippedValue, setGlobalFormV);
              setForAllNew('installedFirmwareVersion', flippedValue, setFormV);
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const cleanValue = nullIfEmpty.setValueAs(e.target.value);
              onChangeGlobal(firmwareName, cleanValue, setGlobalFormV);
              setForAllNew('installedFirmwareVersion', cleanValue, setFormV);
            }}
          />
        </BigInputRowDiv>
      </BigInputDiv>
      <BigInputDiv>
        <GlobalHeader>Installed Software Version</GlobalHeader>
        <BigInputRowDiv>
          <BigCheckBoxInput
            placeholder="Software Version"
            value={installedSoftwareVersion ?? ''}
            showCheckbox={showCheckbox(installedSoftwareVersion)}
            isDisabled={installedSoftwareVersion === NOT_APPLICABLE}
            onClick={() => {
              let flippedValue: string | null = NOT_APPLICABLE;
              if (installedSoftwareVersion === NOT_APPLICABLE) {
                flippedValue = null;
              }
              onChangeGlobal(softwareName, flippedValue, setGlobalFormV);

              setForAllNew('installedSoftwareVersion', flippedValue, setFormV);
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const cleanValue = nullIfEmpty.setValueAs(e.target.value);
              onChangeGlobal(softwareName, cleanValue, setGlobalFormV);
              setForAllNew('installedSoftwareVersion', cleanValue, setFormV);
            }}
          />
        </BigInputRowDiv>
      </BigInputDiv>
    </InputList>
  );
}
export default memo(FirmwareInputGroup);
